import React from 'react';

const Quote = ({text}) => {
  return (
     <div className="py-32 lg:py-32 lg:px-0">
        <div className="quote xl:w-[65%] lg:w-[82%] md:w-[84%] sm:w-11/12 mx-auto bg-lightgray rounded-3xl relative xl:px-8 xl:py-5 lg:p-1 p-2 sm:p-2 xl:max-w-[940px] xl:mx-auto">
            <img className="absolute -top-4 lg:-top-5 lg:left-6 sm:-top-3 sm:left-5 left-8 lg:w-14 w-12 sm:w-8" src="assets/images/quoteiconleft.svg" alt="" />
            <p className="font-black text-center lg:px-9 leading-loose md:leading-[3rem] lg:leading-[4rem] lg:text-3xl md:text-2xl sm:text-[0.870rem] px-14 md:px-4 sm:px-6 py-6">
                  {text}
            </p>
            <img className="quote-right absolute -bottom-4 lg:-bottom-5 sm:-bottom-3 sm:right-5 right-8 lg:right-6 lg:w-14 w-12 sm:w-8" src="assets/images/quoticonright.svg" alt="" />
        </div>
    </div>
  )
}

export default Quote;
